module.exports = __webpack_public_path__ + "static/media/FrequentlyaskedQuestions.880de577.png";